__turbopack_context__.v({
  "isVisible": "oc28iW_isVisible",
  "moreWords": "oc28iW_moreWords",
  "selectedWords": "oc28iW_selectedWords",
  "toLkButton": "oc28iW_toLkButton",
  "tooltip": "oc28iW_tooltip",
  "tooltipDescription": "oc28iW_tooltipDescription",
  "tooltipHeader": "oc28iW_tooltipHeader",
  "tooltipTitle": "oc28iW_tooltipTitle",
  "tooltipType": "oc28iW_tooltipType",
  "word": "oc28iW_word",
});
